module.exports = __webpack_public_path__ + "templates.product_review_entry-c36f879a.html";